export const defaultBaseZIndex = 999999;
